import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import AIVisibility from "@/components/AIVisibility";
import AIMetrics from "@/components/AIMetrics";
import Approach from "@/components/Approach";
import Services from "@/components/Services";
import CaseStudies from "@/components/CaseStudies";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import CTASection from "@/components/CTASection";
import BookingCalendar from "@/components/BookingCalendar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Helmet } from "react-helmet-async";
import { useLanguage } from "@/contexts/LanguageContext";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { OrganizationSchema, WebSiteSchema, ServicesSchema, LocalBusinessSchema, BreadcrumbSchema } from "@/components/seo/StructuredData";

const Index = () => {
  const { language, t } = useLanguage();
  const location = useLocation();

  // Scroll to hash on mount or navigation
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
    }
  }, [location.hash]);

  const homeBreadcrumbs = [
    { name: language === "fr" ? "Accueil" : "Home", url: `https://gogenia.ai/${language}` }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
        <meta property="og:title" content={t("meta.title")} />
        <meta property="og:description" content={t("meta.description")} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://gogenia.ai/${language}`} />
        <meta property="og:image" content="https://gogenia.ai/og-image.png" />
        <link rel="canonical" href={`https://gogenia.ai/${language}`} />
        <html lang={language} />
      </Helmet>

      <OrganizationSchema />
      <WebSiteSchema />
      <ServicesSchema />
      <LocalBusinessSchema />
      <BreadcrumbSchema items={homeBreadcrumbs} />
      
      <Header />
      <main>
        <Hero />
        <Stats />
        <AIVisibility />
        <AIMetrics />
        <Approach />
        <Services />
        <CaseStudies />
        <Pricing />
        <BookingCalendar />
        <FAQ />
        <Contact />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
